export interface PlatformConfigEntry {
  key: string;
  label: string;
  value_type: "secret" | "plaintext";
  is_configured: boolean;
  source: "db" | "env" | null;
  masked: string | null;
  plaintext_val?: string;
  updated_at: string | null;
}

function baseUrl(): string {
  return `${import.meta.env.VITE_SUPABASE_URL as string}/functions/v1/admin-config`;
}

async function request<T>(
  method: string,
  path: string,
  token: string,
  body?: unknown,
): Promise<T> {
  const res = await fetch(`${baseUrl()}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as { error?: string }).error ?? "admin_config_error");
  }
  return res.json() as Promise<T>;
}

export const adminConfigApi = {
  list: (token: string) =>
    request<PlatformConfigEntry[]>("GET", "", token),

  set: (key: string, value: string, token: string) =>
    request<{ key: string; is_configured: boolean; masked?: string; plaintext_val?: string }>(
      "PUT",
      `/${key}`,
      token,
      { value },
    ),

  clear: (key: string, token: string) =>
    request<{ key: string; is_configured: boolean }>("DELETE", `/${key}`, token),
};
